import { render } from "./thar-left-collection-sec.vue?vue&type=template&id=b29d408c&scoped=true"
import script from "./thar-left-collection-sec.vue?vue&type=script&lang=js"
export * from "./thar-left-collection-sec.vue?vue&type=script&lang=js"

import "./thar-left-collection-sec.vue?vue&type=style&index=0&id=b29d408c&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29d408c"]])

export default __exports__